export function getTranslation(lang: string): {
    loginId: string;
    password: string;
    login: string;
    register: string;
    registerAccount: string;
    forgotIdPassword: string;
    whatCanWeHelpYouWith: string;
    seeTopSearches: string;
    startTypingHere: string;
} {
    const translationStrings = {
        en: {
            loginId: 'Login ID',
            password: 'Password',
            login: 'Log in',
            register: 'Register',
            registerAccount: 'Register Account',
            forgotIdPassword: 'Forgot ID or Password',
            whatCanWeHelpYouWith: 'What can we help you with?',
            seeTopSearches: 'See top searches',
            startTypingHere: 'Start typing here…'
        },
        es: {
            loginId: 'ID de inicio de sesión',
            password: 'Contraseña',
            login: 'Iniciar sesión',
            register: 'Registrarse',
            registerAccount: 'Registrar una cuenta',
            forgotIdPassword: 'Olvidé mi ID o contraseña',
            whatCanWeHelpYouWith: '¿En qué podemos ayudarle?',
            seeTopSearches: 'Ver búsquedas principales',
            startTypingHere: 'Empiece a escribir aquí…'
        }
    }
    return translationStrings[lang];
}
